"use strict";

import Cleave from 'cleave.js/dist/cleave-esm.min.js'

let $win = $(window);

let w = window.matchMedia("(max-width: 1281px)");
let vSlide1Roller = document.getElementById("v-slide-1-roller");
let vsSlide1Roller = document.getElementById("vs-slide-1-roller");

const rVideo = document.querySelectorAll(".responsive-video");

window.onload = window.onresize = event => {
    if (w.matches) {
        if (rVideo !== null) {
            rVideo.forEach(function(item) {
                item.parentNode.classList.remove("overlay");
                item.pause();
                item.querySelector("source").src = item.dataset.mobile;
                item.load();
                item.play();
            });
        }

        // vSlide1Roller.parentNode.classList.remove("overlay");
        // vSlide1Roller.pause();
        // vsSlide1Roller.src = vSlide1Roller.dataset.mobile;
        // vSlide1Roller.load();
        // vSlide1Roller.play();
    } else {
        if (rVideo !== null) {
            rVideo.forEach(function(item) {
                item.parentNode.classList.add("overlay");
                item.pause();
                item.querySelector("source").src = item.dataset.desktop;
                item.load();
                item.play();
                console.log(item.dataset.desktop);
            });
        }

        // vSlide1Roller.parentNode.classList.add("overlay");
        // vSlide1Roller.pause();
        // vsSlide1Roller.src = vSlide1Roller.dataset.desktop;
        // vSlide1Roller.load();
        // vSlide1Roller.play();
    }
};

$(function() { 
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        $('.not-yet-modal').css('display', "block !important");
    }

    if ($('input[name="invitation"]').length) {
        new Cleave('input[name="invitation"]', {
            delimiters: ['-', '-'],
            blocks: [4, 4, 4],
            uppercase: true
        })
    }

    let checkEmailExist = true

    //login/signup
    let rec = $('.btn-rec')
    let bck = $('.btn-back')
    let x2 = $('.btn-last')
    let y = $('.icon-clicker')
    let y2 = $('.btn-fpass')
    let notempty = $('#check1, #check2')
    let notempty2 = $('#check3')
    let rewi = $('#lastcheck')
    let pw = $('#check4').val()
    let cw = $('#check5').val()
    let gendert = $('#gendertype')

    //remove the value on the email by default
    if(typeof $('#email') !== "undefined") {
        $('#email').val('')
    }

    $(document).on('click', '.btn-signup, .button-signup', function() {
        $('.form-cont.active').removeClass('active')
        $('.signupform').addClass('active')
        $('.icon-clicker').removeClass('clearme')
        $('.string-small').addClass('clearme')
    })

    $(document).on('click', '.button-login', function() {
        $('.form-cont.active').removeClass('active')
        $('.firstform').addClass('active')
        $('.string-small').addClass('clearme')
    })

    /**
     * Modal Function
     */
    $(document).on('click', '[data-toggle="login-modal"]', function(e) {
        let _this = $(this)
        if (ServerSetup.outSession &&
            (!_this.hasClass('button-login') &&
                !_this.hasClass('button-signup'))) {
            SetOutSession(_this, e)
            return false
        }
        if (typeof _this.attr('disabled') !== "undefined" &&
            _this.hasClass('disabled')) {
            return false
        }
        if (_this.attr("data-target")) {
            let _modal = _this.attr("data-target")
                //fade in modal popup
            $("body").addClass("strings-modal-open")
            if (_modal == ".replay-r1-modal") $("body").addClass("modal-scroll")
            $(_modal).fadeIn()

            if ($(document).find(".toggle-active")) {
                $(".toggle-content").removeClass("toggle-active")
            }
        }
        return false
    })

    $(document).on('click', '.btn-next', function(event) {
        let _this = $(this)
        let fcont = $('.form-cont.active')

        if (_this.attr("rel") === "finish") {
            finishRegistration(_this)

            event.preventDefault()
            return false
        } else {
            var validation = formValidation(_this)
            if (!validation) {
                event.preventDefault()
                return false
            }

            if (_this.attr("rel") === "step-2") {
                //delete the value on the email by default
                $('#email').val('')
            }

            if (_this.attr("rel") === "step-3" &&
                checkEmailExist) {
                event.preventDefault()
                return false
            }

            if (_this.attr("rel") === "step-5" &&
                validation) {
                fillFinalForm()
            }
        }

        fcont.next().addClass('active')
        fcont.removeClass('active')
        if ($('.firstform').hasClass("active")) {
            y.addClass('clearme')
            $('.string-small').addClass('clearme')
        } else {
            y.removeClass('clearme')
            $('.string-small').removeClass('clearme')
        }
    })

    y.on('click', function() {
        let fcont = $('.form-cont.active')
        if ($(this).hasClass('active')) {
            $('.form-cont.active').removeClass('active')
            $('.firstform').addClass('active')
            $(this).removeClass('active')
        } else {
            let fcont = $('.form-cont.active')
            if (fcont.hasClass('first-form')) {
                $('.login-form').addClass('active')
            } else {
                fcont.prev().addClass('active')
            }
            fcont.removeClass('active')
        }
        if ($('.firstform').hasClass("active")) {
            y.addClass('clearme')
            $('.string-small').addClass('clearme')
        } else {
            y.removeClass('clearme')
            $('.string-small').removeClass('clearme')
        }
    })

    y2.on('click', function() {
        $('.form-cont.active').removeClass('active')
        $(".formpass").addClass('active')
        //y.addClass('active')
        if ($('.firstform').hasClass("active")) {
            y.addClass('clearme')
            $('.string-small').addClass('clearme')
        } else {
            y.removeClass('clearme')
            $('.string-small').removeClass('clearme')
        }
    })

    bck.on('click', function() {
        let fcont = $('.form-cont.active')
        fcont.prev().addClass('active')
        fcont.removeClass('active')
        y.addClass('clearme')
    })

    rec.on('click', function() {
        let fcont = $('.form-cont.active')
        $('.firstform').addClass('active')
        fcont.removeClass('active')
        y.addClass('clearme')
        $('.string-small').addClass('clearme')
    })

    x2.on('click', function() {
        $('.form-cont.active').removeClass('active')
        $('.form-cont.firstform').addClass('active')
        y.addClass('clearme')
        $('.string-small').addClass('clearme')
    })

    gendert.change(function() {
        if ($('#other').is(":selected")) {
            $('.hidden-input').show()
        } else {
            $('.hidden-input').hide()
        }
    })

    /**
     * Form Login
     */

    $(document).on("keypress", "#login-email, #login-password", function(event) {
        if (event.key === "Enter") {
            event.preventDefault()
            $("#btn-signin").trigger('click')
        }
    })
    $(document).on("click", "#btn-signin", async function(event) {
        let _this = $(this)
        let form = $("#form-login")
        let wrap = $(".lreg-cont")
        // console.log($("#login-email").val());
        // console.log(form.serialize());return;

        let redirect = ''
        let redirectURL = document.head.querySelector('meta[name="redirect"]')
        if(redirectURL) {
            redirect = redirectURL.content
        }
        form = form.serialize() + '&' + $.param({
            'redirect': redirect
        })
        try {
            setButtonDisabled(_this, true, 0.5)
            let resp = await axios.post('login', form)
            let item = resp.data
            setButtonDisabled(_this)

            if (item.status) {
                let redirect = (item.redirect !== "")
                            ? item.redirect
                            : 'explore'
                window.location.href = `${base_url}/${redirect}`
            } else {
                wrap.css({
                    'height': '550px'
                })
                $(".login-error-message").html(item.error).fadeIn("1000", function() {
                    setTimeout(function() {
                        wrap.css({
                            'height': '511px'
                        })
                        $(".login-error-message").html("").fadeOut()
                    }, 6000)
                })
            }
        } catch(err) {
            console.log(err)
        }
    })

    /**
     * Form Validation
     *
     * @return boolean
     */
    const formValidation = (element) => {
        let parent = element.closest(".form-cont")
        let rel = element.attr("rel")
        let form = parent.find(".required")
        let requiredPass = true

        if (parseInt(form.length) > 0) {
            form.each(function(i, v) {
                let _this = $(this)
                let errorbox = _this.parent().find('span.error-msg')

                if (_this.val() === "") {
                    _this.addClass("has-error")
                    errorbox.html(_this.attr("title") + " is required.")
                    requiredPass = false
                } else if(_this.hasClass('has-error')) {
                    requiredPass = false
                } else {
                    _this.removeClass("has-error")
                    errorbox.html("")
                }
            })
        }

        if (requiredPass) {
            if (rel === "step-3") {
                let email = $("#email")
                let errorbox = email.parent().find('span.error-msg')

                email.removeClass("has-error")
                errorbox.html("")

                if (!emailValidity(email.val())) {
                    email.addClass("has-error")
                    errorbox.html("Invalid email format.")
                }

            } else if (rel === "step-4") {
                let password = $("#password")
                let confirmPassword = $("#confirm-password")
                let errorbox = password.parent().find('span.error-msg')

                password.removeClass("has-error")
                errorbox.html("")

                if (password.val() !== confirmPassword.val()) {
                    password.addClass("has-error")
                    errorbox.html("Password and confirm password does not match.")
                }
            } else if (rel === "step-5") {
                let otherGender = $("#other-gender")
                if (otherGender.is(":visible")) {
                    let errorbox = otherGender.parent().find('span.error-msg')

                    otherGender.removeClass("has-error")
                    errorbox.html("")

                    if (otherGender.val() === "") {
                        otherGender.addClass("has-error")
                        errorbox.html("Please enter your gender.")
                    }
                }
            }
        }

        return parseInt(parent.find('.has-error').length) > 0 ? false : true
    }

    const fillFinalForm = () => {
        //
        let firstname = $("#firstname").val()
        let mname = $("#middlename").val()
        let lastname = $("#lastname").val()
        let email = $("#email").val()
        let birthday = document.getElementById("birthday").value
        var gender = $("#gendertype").val()
        var genderText = $("#gendertype option:selected").attr("title")

        let initial = firstname.charAt(0).toUpperCase() + lastname.charAt(0).toUpperCase()
        let name = firstname
        if (mname !== "") {
            name += " " + mname
        }
        name += " " + lastname

        let color = getRandomColor()
        let initial_path = base_url + "/request/user/initial/100x100/" + color + "/" + initial

        $(".text-initial").html('<img src="' + initial_path + '">')
        $(".text-name").text(name)
        $(".text-email").text(email)
        $(".text-birthday").text(birthday)

        if (gender === "B") {
            genderText = genderText + ", " + $("#other-gender").val()
        }
        $(".text-gender").text(genderText)

        $("#initial").val(initial)
        $("#profilecolor").val(color)
    }

    const clearForm = () => {
        $(".required, #middlename, #reset-email").val("")
    }

    /**
     * email keyup function
     */
     var requestExist = false
     $(document).on("keyup paste", "#invitation", async function(event) {
        let _this    = $(this)
        let button   = $("#btn-invitation")
        let errorbox = _this.parent().find('span.error-msg')

        _this.removeClass("has-error")
        errorbox.html("")

        try {
            if(parseInt(_this.val().length) == 14
                && !requestExist) {
                button.removeClass('btn-skip').text('Next')
                setButtonDisabled(button, true, 0.5)
                requestExist = true
                //Request on the server to check the invitation code if value
                let resp = await axios.post('validate/invitation', { invitational_code: _this.val() })
                let data = await resp.data
                requestExist = false

                if (data.error) {
                    _this.addClass("has-error")
                    errorbox.html( data.error )
                } else {
                    setButtonDisabled(button)
                }
            } else {
                if(requestExist) return false
                setButtonDisabled(button)
                button.addClass('btn-skip').text('Skip')
            }
        } catch (err) {
            console.log(err)
        }
    })

    /**
     * email keyup function
     */
    $(document).on("keyup paste", "#email", async function(event) {
        let _this = $(this)
        let errorbox = _this.parent().find('span.error-msg')
        let btnNext = $(".form-cont.active").find('button.btn-next')

        _this.removeClass("has-error")
        errorbox.html("")

        if (!requestExist && _this.val() !== ""
            && _this.closest(".form-cont").hasClass('active')) {
            if (!emailValidity(_this.val())) {
                _this.addClass("has-error")
                errorbox.html("Invalid email format.")
            } else {
                setButtonDisabled(btnNext, true, 0.5)
                requestExist = true
                let resp = await axios.post('validate/email', { email: _this.val() })
                let data = await resp.data
                setButtonDisabled(btnNext)
                requestExist = false
                if (data.error) {
                    checkEmailExist = true
                    _this.addClass("has-error")
                    errorbox.html( data.error )
                } else {
                    checkEmailExist = false
                }
            }
        }
    })

    /**
     * password keyup function
     */
    $(document).on("keyup", "#password", function(event) {
        let _this = $(this)
        let errorbox = _this.parent().find('span.error-msg')

        _this.removeClass("has-error")
        errorbox.html("")
        if (_this.val() !== "") {
            if (parseInt(_this.val().length) >= 6) {
                // if(!passwordValidity(_this.val())) {
                //     _this.addClass("has-error")
                //     errorbox.html( "Weak Password." )
                // } else {
                _this.removeClass("has-error")
                //}
            } else {
                _this.addClass("has-error")
                errorbox.html("Password is too short.")
            }
        }
    })

    /**
     * Event to clear the error message to all required fields
     */
    $(document).on("keyup", ".required", function(event) {
        let _this = $(this)
        let id = _this.attr("id")
        let lengthValue = parseInt(_this.val().length)

        if (id === "birthday") {
            if (lengthValue == 0) {
                _this.addClass('has-error')
                _this.parent().find('span.error-msg').html('Plese enter valid date format.')
            } else {
                let currentAge = calculateTwoDatesOnYears(_this.val())
                if(currentAge < 18) {
                    _this.addClass('has-error')
                    _this.parent().find('span.error-msg').html('Invalid age you must be 18 years old above.')
                } else {
                    _this.removeClass('has-error')
                    _this.parent().find('span.error-msg').html('')
                }
            }
        } else if (lengthValue > 0 && !['email'].includes(id)) {
            _this.removeClass('has-error')
            _this.parent().find('span.error-msg').html('')
        }
    })
    $(document).on("change", "#birthday", function(event) {
        let _this = $(this)
        let currentAge = calculateTwoDatesOnYears(_this.val())
        if(currentAge < 18) {
            _this.addClass('has-error')
            _this.parent().find('span.error-msg').html('Invalid age you must be 18 years old above.')
        } else {
            _this.removeClass('has-error')
            _this.parent().find('span.error-msg').html('')
        }
    })

    /**
     * Finish Registration method
     */
    const finishRegistration = async (target) => {
        let fcont = $('.form-cont.active')
        let form = $("#form-registration")

        try {
            setButtonDisabled(target, true, 0.5)
            target.text('Please wait, while saving your data...')
            let resp = await axios.post('registration', form.serialize())
            let item = await resp.data

            setButtonDisabled(target)
            if(item.errors) return false

            clearForm()
            fcont.next().addClass('active')
            fcont.removeClass('active')
            y.addClass('clearme')
        } catch (err) {
            console.log(err)
        }
    }

    /**
     * Forgot Password Reset
     */
    $(document).on("click", "#btn-resetpassword", async function(event) {
        let _this = $(this)
        let fcont = $('.form-cont.active')
        let email = fcont.find("#reset-email")

        let errorbox = $('#reset-error-msg')

        email.removeClass("has-error")
        errorbox.html("")
        console.log(email.val())
        if (email.val() !== "") {
            if (!emailValidity(email.val())) {
                email.addClass("has-error")
                errorbox.html("Invalid email format.")
            } else {
                try {
                    setButtonDisabled(_this)
                    _this.text('Processing your request, please wait...')
                    let resp = await axios.post('resetpassword', { email: email.val() })
                    let data = await resp.data

                    setButtonDisabled(_this)
                    _this.text('Send Recovery Email')
                    if (data.status) {
                        clearForm()
                        fcont.next().addClass('active')
                        fcont.removeClass('active')
                        y.addClass('clearme')
                    } else {
                        email.addClass("has-error")
                        errorbox.html(data.error)
                    }
                } catch (err) {
                    console.log(err)
                }
            }
        } else {
            email.addClass("has-error")
            errorbox.html("Please enter your email.")
        }
    })

    $(document).on("click", "#btn-setnewpassword", async function(event) {
        let _this = $(this)
        let fcont = $('.form-cont.active')
        let form = $("#resetPasswordForm")
        let password = $("#password")
        let confirmPassword = $("#confirm-password")
        if (password.hasClass('has-error') || password.val() === "") return false
        if (password.val() !== confirmPassword.val()) {
            confirmPassword.addClass("has-error")
            confirmPassword.parent().find('span.error-msg').html("Please make sure your passwords match.")

            return false
        }

        try {
            setButtonDisabled(_this, true, 0.5)
            _this.text('Processing your request, please wait...')

            let resp = await axios.post('setpassword', form.serialize())
            let data = await resp.data

            setButtonDisabled(_this)
            _this.text('Reset Password')

            if (data.status) {
                y.addClass('clearme')
                fcont.next().addClass('active')
                fcont.remove()
            } else {
                password.addClass("has-error")
                password.parent().find('span.error-msg').html(data.error)
            }

        } catch (err) {
            console.log(err)
        }
    })
});

let Landing = {
    init: function() {
        $(document).on("click", ".strings-modal-window", function(e) {
            if ($(this).hasClass('terms-modal') || $(this).hasClass('privacy-modal')) {
                $("body").removeClass("strings-modal-open")
                $(this).closest(".strings-modal-window").fadeOut()
            }
        });
    },

    playVideoOnScroll: function() {
        if ($("video").length) {
            var loadVideo;

            $("video").each(function(number) {
                $(this).attr("webkit-playsinline", "");
                $(this).attr("playsinline", "");
                $(this).attr("muted", "muted");

                $(this).attr("id", "loadvideo" + number);
                loadVideo = document.getElementById("loadvideo" + number);
                loadVideo.load();
            });

            $win.scroll(function() {
                // video to play when is on viewport
                $("video").each(function() {
                    if (Landing.isScrolledIntoView(this) == true) {
                        $(this)[0].play();
                    } else {
                        $(this)[0].pause();
                    }
                });

                $(".focus-solution").each(function() {
                    if (Landing.isScrolledIntoView(this) == true) {
                        $(this).addClass("active");
                    } else {
                        $(this).removeClass("active");
                    }
                });
            });
        }
    },

    isScrolledIntoView: function(elem) {
        let elementTop, elementBottom, viewportTop, viewportBottom;
        elementTop = $(elem).offset().top;
        elementBottom = elementTop + $(elem).outerHeight();
        viewportTop = $win.scrollTop();
        viewportBottom = viewportTop + $win.height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    },

    smoothScrolling: function() {
        // Add smooth scrolling to all links
        $('a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .click(function(event) {
                $('a[href*="#"]')
                    .closest("li")
                    .removeClass("active");
                $(this)
                    .closest("li")
                    .addClass("active");

                // On-page links
                if (
                    location.pathname.replace(/^\//, "") ==
                        this.pathname.replace(/^\//, "") &&
                    location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length
                        ? target
                        : $("[name=" + this.hash.slice(1) + "]");
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $("html, body").animate(
                            {
                                scrollTop: target.offset().top
                            },
                            1000,
                            function() {
                                // Callback after animation
                                // Must change focus!
                                var $target = $(target);
                                $target.focus();
                                if ($target.is(":focus")) {
                                    // Checking if the target was focused
                                    return false;
                                } else {
                                    $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                                    $target.focus(); // Set focus again
                                }
                            }
                        );
                    }
                }
            });
    }
};

$(function() {
    Landing.init();
    Landing.playVideoOnScroll();
    Landing.smoothScrolling();

    function mobilecheck() {
        var check = false;
        (function(a) {
            if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                check = true;
            }
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }
    var clickevent = mobilecheck() ? 'touchstart' : 'click';

    var items = $('.slide');
    var content = $('.content');

    function open() {
        $(items).removeClass('close').addClass('open');
    }

    function close() {
        $(items).removeClass('open').addClass('close');
    }

    $('#navToggle').on(clickevent, function(event) {
        event.stopPropagation();
        event.preventDefault();
        if (content.hasClass('open')) {
            close();
        } else {
            open();
        }
    });
    content.click(function() {
        if (content.hasClass('open')) {
            close();
        }
    });
});
